import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { doGetOrderList } from 'src/actions';
import { GetOrderListQueryParamsDto } from 'src/dtos';
import { Order } from 'src/models';

import { CustomHookBaseOptions } from '../models/common.model';

import { useAccountSelector } from './useAccountSelector';

interface UseOrdersReturnType {
  orderList: Order[];
  isOrderListLoading: boolean;
  hasOrderListError?: boolean;
  orderListError?: string;
  isOrderListFetched: boolean;
}

export interface UseOrdersOptions extends CustomHookBaseOptions {
  queryParamsDto?: GetOrderListQueryParamsDto;
}

const EMPTY_ORDERS: Order[] = [];

export const useOrders = ({ skip, queryParamsDto }: UseOrdersOptions = { skip: false }): UseOrdersReturnType => {
  const dispatch = useDispatch();
  const orderList: Order[] | undefined = useSelector((state: any) => state.orders.list?.data?.data);
  const isOrderListLoading = useSelector((state: any) => Boolean(state.orders?.list?.__requested));
  const hasOrderListFailed: boolean = useSelector((state: any) => state.orders.list?.__failed);
  const orderListError: string = useSelector((state: any) => state.orders.list?.__message);
  const isFetched: boolean = useSelector((state: any) => Boolean(state.orders.list?.__isFetched));
  const { account } = useAccountSelector();

  useEffect(() => {
    if (!orderList && !isOrderListLoading && !skip && !hasOrderListFailed && account?.accountId) {
      dispatch(doGetOrderList({ params: { accountId: account.accountId }, queryParams: queryParamsDto }));
    }
  }, [orderList, isOrderListLoading, dispatch, account?.accountId, queryParamsDto]);

  return {
    orderList: Array.isArray(orderList) ? orderList : EMPTY_ORDERS,
    isOrderListLoading,
    hasOrderListError: hasOrderListFailed,
    orderListError,
    isOrderListFetched: isFetched,
  };
};
